import React from 'react';

const BlogHighlightsSection = ({ highlights }) => {
  return (
    <section aria-labelledby="topics-title" className="mb-20">
      <div className="max-w-2xl mx-auto text-center">
        <h2
          id="topics-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          O que encontrará aqui
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Conteúdo prático, checklists e análises focadas em aplicação direta no dia a dia de
          desenvolvimento.
        </p>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {highlights.map((item) => (
          <div
            key={item.id}
            className="bg-white p-6 rounded-lg border border-gray-200 shadow-lg site-card"
          >
            <h3 className="text-xl font-semibold text-gray-900">{item.title}</h3>
            <p className="mt-3 text-gray-600">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogHighlightsSection;
